

export class DeviceModelPortAllocationStatusInput implements IDeviceModelPortAllocationStatusInput {
    /** The auto-generated id of the deviceModelPortAllocation master */
    deviceModelPortAllocationId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IDeviceModelPortAllocationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceModelPortAllocationId = _data["deviceModelPortAllocationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeviceModelPortAllocationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceModelPortAllocationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceModelPortAllocationId"] = this.deviceModelPortAllocationId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeviceModelPortAllocationStatusInput {
    /** The auto-generated id of the deviceModelPortAllocation master */
    deviceModelPortAllocationId: number;
    /** The updated status */
    status: number;
}

